import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { ContactFormSectionProps } from '../shared/types';

const ContactFormSection: React.FC<ContactFormSectionProps> = ({ title, children }) => (
  <Paper elevation={0}>
    <Typography variant="h3" mb={2}>
      {title}
    </Typography>
    <Box display="flex" flexDirection="column" gap={2}>
      {children}
    </Box>
  </Paper>
);

export default ContactFormSection;
